import { C } from '../../constants/colors.js';
import { N } from '../../constants/fonts.js';

export function TB({ min, sec, totalMin, color }) {
  const pct = totalMin > 0 ? ((min*60+sec)/(totalMin*60))*100 : 100;
  return (
    <div style={{display:"flex",alignItems:"center",gap:8}}>
      <div style={{flex:1,height:6,background:"#F0F0F5",borderRadius:3,overflow:"hidden"}}>
        <div style={{height:"100%",width:`${pct}%`,background:pct<20?C.danger:color||C.primary,borderRadius:3,transition:"width 1s linear"}}/>
      </div>
      <span style={{fontFamily:N,fontSize:12,color:pct<20?C.danger:C.textLight,fontWeight:700,minWidth:42,textAlign:"right"}}>
        {min}:{String(sec).padStart(2,"0")}
      </span>
    </div>
  );
}
